import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { convertPxToVw } from '../../utils';
let Picture = class Picture extends Vue {
    constructor() {
        super(...arguments);
        this.timer = null;
        this.number = 0;
    }
    get style() {
        let top = parseInt(this.data.top);
        return `
      height: ${convertPxToVw(this.data.height)}vw;
      width: ${convertPxToVw(this.data.width)}vw;
      font-size: ${convertPxToVw(this.data.fontSize)}vw;
      color: ${this.data.textColor};
      top: ${convertPxToVw(top)}vw;
      left: ${convertPxToVw(this.data.left)}vw;
      background: rgba(${this.getRGB(this.data.bgColor)}, ${this.data.opacity /
            100});
      --leaveHeight: ${convertPxToVw(-this.data.height)}vw;
      --enterHeight: ${convertPxToVw(this.data.height)}vw;
    `;
    }
    get text() {
        if (!this.data.content || !this.data.content[this.number])
            return '';
        return {
            id: this.number,
            val: this.data.content[this.number].value,
        };
    }
    mounted() {
        this.startMove();
        this.$el.parentElement.style = 'position: static';
    }
    getRGB(arr) {
        arr = arr.substr(1);
        let a = [];
        for (let i = 0; i < 3; i++) {
            let str = arr.substr(i * 2, 2);
            a[i] = parseInt(str, 16);
        }
        return a.join(',');
    }
    startMove() {
        clearInterval(this.timer);
        let len = this.data.content.length - 1;
        if (len === 0)
            return;
        this.timer = setInterval(() => {
            if (this.number === len) {
                this.number = 0;
            }
            else {
                this.number += 1;
            }
        }, 5000);
    }
};
tslib_1.__decorate([
    Prop()
], Picture.prototype, "data", void 0);
Picture = tslib_1.__decorate([
    Component
], Picture);
export default Picture;
